export const NSW_MARKER_COLOR = "#0072B2";
export const NSW_MARKER_HOURLY_COLOR = "#009E73";
export const NSW_MARKER_SELECTED_COLOR = "#D55E00";

export const NSW_CARDINAL_COLORS = {
  NORTH: "#0072B2",
  SOUTH: "#D55E00",
  EAST: "#009E73",
  WEST: "#CC79A7",
  BOTH: "#4477AA",
  "NORTHBOUND AND SOUTHBOUND": "#56B4E9",
  "EASTBOUND AND WESTBOUND": "#E69F00"
};

export const NSW_HOURLY_DAY_KEYS = [
  "MON",
  "TUE",
  "WED",
  "THU",
  "FRI",
  "SAT",
  "SUN",
  "WEEKDAY_AVERAGE",
  "WEEKEND_AVERAGE"
];

export const NSW_HOURLY_DAY_LABELS = {
  MON: "Monday",
  TUE: "Tuesday",
  WED: "Wednesday",
  THU: "Thursday",
  FRI: "Friday",
  SAT: "Saturday",
  SUN: "Sunday",
  WEEKDAY_AVERAGE: "Weekday avg",
  WEEKEND_AVERAGE: "Weekend avg"
};

export const DEFAULT_NSW_HOURLY_DAYS = ["WEEKDAY_AVERAGE", "WEEKEND_AVERAGE"];
